<template>
    <div v-if="marktime" class="sticky" style="top: 68px;">
        <table class="table">
            <thead>
                <tr>
                    <th class="center aligned" colspan="3">Overview</th>
                </tr>
                <tr>
                    <th></th>
                    <th>Days</th>
                    <th>Hours</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Working</td>
                    <td class="text-center">{{ workingDays }}</td>
                    <td class="text-center">{{ workingHours }}</td>
                </tr>
                <tr v-for="reason in reasons" :key="reason.id">
                    <td>{{ reason.name }} (<b>{{ reason.id }}</b>)</td>
                    <td class="text-center">{{ getReasonDays(reason.id) }}</td>
                    <td class="text-center">{{ getReasonHours(reason.id) }}</td>
                </tr>
                <tr>
                    <td>Overtime</td>
                    <td class="text-center">-</td>
                    <td class="text-center">{{ overtimeHours }}</td>
                </tr>
                <tr>
                    <td><b>Total</b></td>
                    <td class="text-center"><b>{{ totalDays }}</b></td>
                    <td class="text-center"><b>{{ totalHours }}</b></td>
                </tr>
                <tr>
                    <td>Meal contribution</td>
                    <td colspan="2" class="text-center"><b>{{ vouchers }}</b></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import moment from 'moment';
import { mapState } from "vuex";
import mixinMarktime from '../mixins/marktime'

export default {

    mixins: [
        mixinMarktime
    ],

    computed: {

        ...mapState({
            currentUser: state => state.user.info
        }),

    },

}
</script>